// extracted by mini-css-extract-plugin
module.exports = {"selection":"_ee0affa","oddsBoost":"_9f557e9"};